// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__13GMe","errorLogs":"styles_errorLogs__1YWvu"};